var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeakerIndicatorStatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_3026)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#36C1E2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13.75,
    width: 5,
    height: 12.5,
    rx: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 10,
    width: 5,
    height: 20,
    rx: 2.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 13.75,
    width: 5,
    height: 12.5,
    rx: 2.5,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_3026"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerIndicatorStatic);
export default __webpack_public_path__ + "static/media/speaker-indicator-static.5fc911b9f9dc2ff6feff4835d8ae8024.svg";
export { ForwardRef as ReactComponent };